<template lang="html">
  <div>
    <v-row>
      <v-col>
        <v-tabs
          v-model="tabSelected"
          class="elevation-3"
          icons-and-text
          grow
        >
          <v-tab
            v-for="(tab,i) in tabs"
            :key="i"
          >
            {{ tab.text }}
            <v-icon>{{ tab.icon }}</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items 
          v-model="tabSelected"
          class="elevation-3"
        >
          <div v-show="isTabOne">
            <setup-job-position-job-title-levels-leave-form-update
              :position="position"
              @close-dialog="closeDialog"
            />
          </div>

          <div v-show="isTabTwo">
            <setup-job-position-job-title-authorities-leave-form-update
              :position="position"
              @close-dialog="closeDialog"
            />
          </div>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobTitleLevelsLeaveFormUpdate: () => import('@/components/hris/setup/job-position/job-title/levels/LeaveFormUpdate'),
      SetupJobPositionJobTitleAuthoritiesLeaveFormUpdate: () => import('@/components/hris/setup/job-position/job-title/authorities/LeaveFormUpdate'),
    },
    props: {
      position: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        tabSelected: 0,
        tabs: [
          { text: 'Approval Requirement', icon: 'mdi-account-multiple-plus' },
          { text: 'Authorize Leave', icon: 'mdi-account-check-outline' },
        ],
      }
    },
    computed: {
      isTabOne () {
        return this.tabSelected === 0
      },
      isTabTwo () {
        return this.tabSelected === 1
      },
    },
    methods: {
      closeDialog () {
        this.$emit('close-dialog')
      },
    },
  }
</script>

<style lang='css'>
</style>
